import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ValueSystem.scss";
import valueSystemImg from "../../img/values.png"; // Replace with actual path
import goalsImg from "../../img/goals.png"; // Replace with actual path

const ValueSystem = () => {
  return (
    <section className="value-system container py-5">
      {/* Value System Image */}
      <div className="text-center">
        <img src={valueSystemImg} alt="Value System" className="img-fluid value-img" />
      </div>

      {/* Our Goals Image */}
      <div className="text-center mt-5">
        <img src={goalsImg} alt="Our Goals" className="img-fluid goals-img" />
      </div>
    </section>
  );
};

export default ValueSystem;
